import {
  Box,
  MenuItem as MuiMenuItem,
  Select as MuiSelect,
  Typography,
} from "@mui/material";
import { menuItemClasses } from "@mui/material/MenuItem";
import { selectClasses } from "@mui/material/Select";
import { styled } from "@mui/material/styles";
import * as React from "react";
import ShippingProfileSelector from "./shippingProfileSelector";

const MenuItem = styled(MuiMenuItem)(({ theme }) => ({
  [`&.${menuItemClasses.root}`]: {
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
  },
  [`&.${menuItemClasses.selected}`]: {
    // background: "red",
  },
}));

const Select = styled(MuiSelect)(({ theme }) => ({
  [`.${selectClasses.select}`]: {
    paddingRight: 40,
  },
  [`.${selectClasses.icon}`]: {
    right: 10,
    transition: theme.transitions.create(["transform"]),
  },
  [`.${selectClasses.iconOpen}`]: {
    transform: "rotate(180deg)",
  },
}));

export default function ShippingProfileSection(): React.ReactElement {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: {
          xs: "flex-start",
          md: "center",
        },
        flexDirection: {
          xs: "column",
          md: "row",
        },
        pb: 2,
        borderBottom: "1px solid",
        borderBottomColor: (theme) => theme.palette.divider,
      }}
    >
      <Box>
        <Typography
          variant="h6"
          sx={{
            mb: {
              xs: 0.5,
              md: 0,
            },
          }}
        >
          Shipping Profile
        </Typography>
      </Box>
      <Box
        sx={{
          flex: 1,
          width: { xs: "100%", md: "auto" },
          mt: { xs: 1, md: 0 },
        }}
      >
        <Box sx={{ ml: "auto", maxWidth: { xs: "auto", md: 400 } }}>
          <ShippingProfileSelector />
        </Box>
      </Box>
    </Box>
  );
}
